// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostAsrFilterConfigTalkerRecognitionConfigBody, BaseResponseVoid } from '../../types';

/**
 * talkerRecognitionConfigUpsert
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [POST] /asr-filter-config/talkerRecognitionConfig
 */
export function postAsrFilterConfigTalkerRecognitionConfig(
    data: PostAsrFilterConfigTalkerRecognitionConfigBody
): Promise<BaseResponseVoid>;
export function postAsrFilterConfigTalkerRecognitionConfig(
    data: PostAsrFilterConfigTalkerRecognitionConfigBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postAsrFilterConfigTalkerRecognitionConfig(
    data: PostAsrFilterConfigTalkerRecognitionConfigBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostAsrFilterConfigTalkerRecognitionConfigBody, never, never>(
        '/asr-filter-config/talkerRecognitionConfig',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postAsrFilterConfigTalkerRecognitionConfig',
        }
    );
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/talkerRecognitionConfig',
        method: 'post',
    },
];
